import React, { FC, useState } from 'react';
import s from './expandableText.module.scss';
import { Button, ButtonProps } from '../Button/Button';
import parse from 'html-react-parser';
import truncate from 'truncate-html';
import { useTranslation } from '@hooks/useTranslation';
import cn from 'classnames';
import { stripHtmlTags } from '@services/post/helpers';
type ExpandableTextProps = {
  text: string;
  maxLength?: number;
  className?: string;
  boxClassName?: string;
  buttonProps?: Partial<ButtonProps>;
};
const defaultButtonProps: Omit<ButtonProps, 'children' | 'id'> = {
  color: 'Transparent',
  size: 'small'
};
export const ExpandableText: FC<ExpandableTextProps> = ({
  text,
  maxLength = 100,
  className,
  boxClassName,
  buttonProps
}) => {
  const {
    translate: tr
  } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const plainText = stripHtmlTags(text);
  const isLongText = plainText.length > maxLength;
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const truncatedText = isExpanded ? text : truncate(text, {
    length: maxLength
  });
  return <div className={cn(s.expandableText, boxClassName)} data-sentry-component="ExpandableText" data-sentry-source-file="ExpandableText.tsx">
            {/* TODO при первом рендере truncatedText может быть undefined и упадет с ошибкой, хотя он не должен рендерится без текста */}
            <p className={cn(s.accordion__text, className)}>{parse(truncatedText ?? '')}</p>

            {isLongText && <Button id='expandable_text_button' className={s.expandableText__button} onClick={toggleExpand} icons={{
      left: {
        name: isExpanded ? 'minus' : 'plus'
      }
    }} {...defaultButtonProps} {...buttonProps}>
                    {isExpanded ? tr({
        id: 'btn.show.less'
      }) : tr({
        id: 'btn.show.more'
      })}
                </Button>}
        </div>;
};